
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import EditCalendarIcon from "@mui/icons-material/EditCalendar"
import React from "react"
import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Icons from "@src/components/Icons"
import { JobStatus, CustomButton } from ".."
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import Skeleton from "@mui/material/Skeleton"
import DangerouslySetInnerHTML from "@src/components/DangerouslySetInnerHTML"
import { padding, width } from "@mui/system"
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter"
import dayjs from "dayjs"
import { GridContainer } from "@src/components/style-box"
import Grid from "@mui/material/Grid"
const JobCard = props => {
  const {
    loading,
    title,
    jobType,
    department,
    to_date, // new prop
    onClickDetail
  } = props

  if (loading) {
    return (
      <Paper
        sx={{
          borderRadius: 1,
          padding: 1,
          boxShadow: "4px 0px 32px -2px rgba(16, 24, 40, 0.08)",
          display: "flex",
          cursor: "pointer",
          position: "relative",
          overflow: "hidden",
          pointerEvents: "none",
          "&:hover": {
            "& #job-hover": {
              display: "block",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#808080b0",
              borderRadius: 1
            },
            "& .btn-detail": {
              bottom: "50%",
              transform: "translateY(50%)"
            }
          }
        }}
      >
        <Box
          sx={{
            marginRight: 1
          }}
        >
          <Skeleton animation="wave" height={50} width={40} />
        </Box>
        <Stack width="100%" flexDirection="column" p={2}>
          <Skeleton animation="wave" height={24} width={200} />
          <Stack
            alignItems="center"
            spacing={1}
            mt={0.5}
            mb={1.5}
            sx={{
              "& p": {
                fontSize: "12px",
                color: "#7D7D7D"
              }
            }}
          >
            <Skeleton animation="wave" height={20} width={120} />
          </Stack>
          <Skeleton animation="wave" variant="rectangular" height={60} />
        </Stack>
      </Paper>
    )
  }

  return (
    <Paper
      sx={{
        padding: {
          md: 2
        },
        height: "100%",
        display: "flex",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        transition: "box-shadow 0.3s",
        "&:hover": {
          boxShadow: "0 8px 32px 0 rgba(16, 24, 40, 0.18)"
        },
        backgroundColor: "transparent",
        boxShadow: "none",
        borderBottom: "1px solid #E0E0E0",
        borderRadius: 0
      }}
      onClick={onClickDetail}
    >
      <Stack
        flexDirection="column"
        p={{
          xs: 1,
          sm: 2
        }}
        sx={{ width: "100%" }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            className="truncate-1"
            variant="h5"
            component="p"
            fontWeight={500}
            fontSize={{
              xs: 13,
              sm: 18
            }}
            lineHeight="24px"
          >
            {title}
          </Typography>
          <CustomButton
            sx={{
              borderRadius: "15px",
              width: {
                xs: "50px",
                sm: "80px"
              },
              height: {
                xs: "15px",
                sm: "20px"
              },
              minHeight: {
                xs: "15px",
                sm: "20px"
              },
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& svg": {
                scale: {
                  xs: "0.6 !important",
                  sm: "1 !important"
                }
              }
            }}
            type="button"
            label={<Icons name="flat-arrow-right" />}
          />
        </Box>
        <GridContainer
          sx={{
            color: "#BDBDBD",
            fontWeight: 500,
            fontSize: 14,
            "& .MuiSvgIcon-root": { fontSize: 18 },
            mt: {
              xs: 0,
              sm: 2
            },
            mb: 2
          }}
        >
          <Grid
            item
            xs={4}
            md={4}
            sx={{ display: "flex", alignItems: "center", width: "100%" }}
          >
            <AccessTimeIcon />
            <Typography
              variant="body1"
              color="#BDBDBD"
              fontWeight={600}
              fontSize={{
                xs: 8,
                sm: 14,
                md: 16
              }}
              sx={{ ml: 1 }}
            >
              {jobType}
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            md={4}
            sx={{ display: "flex", alignItems: "center", width: "100%" }}
          >
            <BusinessCenterIcon />
            <Typography
              variant="body1"
              color="#BDBDBD"
              fontWeight={600}
              fontSize={{
                xs: 8,
                sm: 14,
                md: 16
              }}
              lineHeight="10px"
              sx={{ ml: 1 }}
            >
              {department}
            </Typography>
          </Grid>
          <Grid
            item
            xs={5}
            md={4}
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end"
            }}
          >
            <EditCalendarIcon />
            <Typography
              variant="body1"
              color="#BDBDBD"
              fontWeight={600}
              fontSize={{
                xs: 8,
                sm: 14,
                md: 16
              }}
              lineHeight="10px"
              sx={{ ml: 1 }}
            >
              {to_date
              ? `Ngày hết hạn: ${dayjs(to_date).format("DD.MM.YY")}`
                : ""}
            </Typography>
          </Grid>
        </GridContainer>
      </Stack>
    </Paper>
  )
}

export default JobCard
